import { FORM_FIELD, PAYMENT_LINK_TYPE, paymentLinkRequiredFields, recurrentLinkRequiredFields } from "../constants"

export const checkCanCreateLink = (values = {}) => {
  if(!values[FORM_FIELD.LINK_TYPE]) {
    return false;
  }

  if(values[FORM_FIELD.LINK_TYPE] === PAYMENT_LINK_TYPE.PAYMENT_LINK) {
    return paymentLinkRequiredFields.every(field => {
      if(field === FORM_FIELD.EXTENSION_DAYS && values[FORM_FIELD.IS_LIFETIME]) {
        return true;
      }
      
      return values[field];
    });
  }

  if(values[FORM_FIELD.LINK_TYPE] === PAYMENT_LINK_TYPE.RECURRENT) {
    return recurrentLinkRequiredFields.every(field => {
      if(field === FORM_FIELD.EXTENSION_DAYS && values[FORM_FIELD.IS_LIFETIME]) {
        return true;
      }
      
      return values[field];
    });
  }
}

export const validateValues = (values = {})=> {
  let errors = {};

  if(!values[FORM_FIELD.LINK_TYPE]) {
    errors = {
      [FORM_FIELD.LINK_TYPE]: 'É necessário informar o tipo de link de extensão'
    }

    return {
      hasError: true,
      errors
    }
  }

  if(values[FORM_FIELD.LINK_TYPE] === PAYMENT_LINK_TYPE.PAYMENT_LINK) {
    const ignoredFields = [
      FORM_FIELD.EXTENSION_DAYS,
      FORM_FIELD.IS_LIFETIME
    ]

    const errors = paymentLinkRequiredFields.reduce((prev, field) => {
      const value = values[field];

      if(!ignoredFields.includes(field) && !value) {
        return {
          ...prev,
          [field]: 'Campo não pode ficar vazio'
        }
      }

      if(field === FORM_FIELD.EXTENSION_DAYS && +value < 1 && !values[FORM_FIELD.IS_LIFETIME]) {
        return {
          ...prev,
          [field]: 'Os dias de validade devem ser maior ou igual a 1'
        }
      }

      if(field === FORM_FIELD.TOTAL && +value.replace(',', '.') <= 1) {
        return {
          ...prev,
          [field]: 'O total deve ser maior que 1,00'
        }
      }

      return prev;
    }, {});

    return {
      hasError: Object.values(errors).filter(Boolean).length > 0,
      errors
    }
  }

  if(values[FORM_FIELD.LINK_TYPE] === PAYMENT_LINK_TYPE.RECURRENT) {
    const ignoredFields = [
      FORM_FIELD.EXTENSION_DAYS,
      FORM_FIELD.IS_LIFETIME
    ]

    const errors = recurrentLinkRequiredFields.reduce((prev, field) => {
      const value = values[field];

      if(!ignoredFields.includes(field) && !value) {
        return {
          ...prev,
          [field]: 'Campo não pode ficar vazio'
        }
      }

      if(field === FORM_FIELD.EXTENSION_DAYS && +value < 1) {
        return {
          ...prev,
          [field]: 'Os dias de validade devem ser maior ou igual a 1'
        }
      }

      if(field === FORM_FIELD.CYCLES && +value < 1) {
        return {
          ...prev,
          [field]: 'A quantidade de parcelas deve ser maior ou igual a 1'
        }
      }

      if(field === FORM_FIELD.CYCLE_PRICE && +value.replace(',', '.') <= 1) {
        return {
          ...prev,
          [field]: 'O valor da parcela deve ser maior que 1,00'
        }
      }

      return prev;
    }, {});

    return {
      hasError: Object.values(errors).filter(Boolean).length > 0,
      errors
    }
  }
}